import React, { useEffect, useState, useContext } from 'react';
import TextInput from '../UI/TextInput';
import EmailInput from '../UI/EmailInput';
import MultiSelect from '../UI/MultiSelect';
import DateRange from '../UI/DateRange';
import PasswordInput from '../UI/PasswordInput';
import TextArea from '../UI/TextArea';
import { TabContext } from '../../context/TabContext';
import Radio from '../UI/Radio';

const SingleSelect = props => {
  const [check, setCheck] = useState(false);
  const [firstRender, setFirstRender] = useState(true);
  const { 
    resetTrigger, 
    register, 
    onChangeHandler, 
    handleMultiChange, 
    inputValue, 
    list, 
    selectValue, 
    handleTimeCallback, 
    setInputValue, 
    setSelectValue,
    onChangeSingleValue
  } = useContext(TabContext);

  const inputPermitionHandler = () => {
    setCheck(!check);
  }

  useEffect(() => {
    
    if (!check && !firstRender) {
      setInputValue({
        ...inputValue,
        [props.name]: ""
      })

      setSelectValue(
        selectValue.filter(item => item.type !== props.name)
      )
    }
    setFirstRender(false);
  }, [check]);

  useEffect(() => {
    setCheck(false);
  }, [resetTrigger]);

  return (
    <div className="advanced-option">
      <div className="Checkbox_Wrap mr-5">
        <input
          label="check"
          type="checkbox"
          name={props.name}
          id={props.id} 
          onClick={inputPermitionHandler}
        />
        <label htmlFor={props.id}></label>
      </div>
      <h6>
        {props.label}
      </h6>
      {props.type === "text" && (
        <TextInput 
          name={props.name} 
          type={props.type} 
          register={register()}
          check={check}
          value={inputValue[props.name]}
          onChange={onChangeSingleValue}
          placeholder="Type something..."
          setInputValue={setInputValue}
          inputValue={inputValue}
        />
      )}
      {props.type === "textarea" && (
        <TextArea 
          name={props.name} 
          register={register()}
          check={check}
          value={inputValue[props.name]}
          onChange={onChangeSingleValue}
          placeholder="Up To 600 characters"
        />
      )}
      {props.type === "email" && (
        <EmailInput 
          name={props.name} 
          type={props.type} 
          register={register()}
          check={check}
          value={inputValue[props.name]}
          onChange={onChangeSingleValue}
          placeholder="Type something..."
        />
      )}
      {props.type === "password" && (
        <PasswordInput 
          name={props.name} 
          tabs={true}
          type={props.type} 
          register={register()}
          value={inputValue[props.name]}
          onChange={onChangeSingleValue}
          placeholder="Type something..."
          infoType={props.info_type}
        />
      )}
       {props.type === "tel" && (
        <input 
          name={props.name}
          id={props.name}
          ref={register()}
          placeholder="Type something..."
          onChange={onChangeSingleValue && ((event) => onChangeSingleValue(event, props.name))}
          value={inputValue && inputValue[props.name]}
          type={props.type}
        />
      )}
      {props.type === "date" && (
        <DateRange
          handleTimeCallback={handleTimeCallback}
          name={props.name}
          id={props.name}
          wrapStyle="advanced-picker-wrap"
          check={check}
          cancelCallback = {() => {setInputValue({
            ...inputValue,
            [props.name]: {}
          })}}
          isPicked = {()=>Object.keys(inputValue[props.name]).length === 0}
        />
      )}
      {props.type === "select" && (
        <MultiSelect 
          onChangeHandler={onChangeHandler}
          handleMultiChange={handleMultiChange}
          name={props.name}
          list={list}
          inputValue={inputValue && inputValue[props.name]}
          selectValue={selectValue.filter(item => item.type === props.name)}
          styles="react-select-container advanced"
          prefixStyles="react-select"
          indicator={false}
          check={check}
        />
      )}
      {props.type === "radio" && (
        <Radio 
          check={check}
          register={register()}
          props={props}
          onChangeSingleValue={onChangeSingleValue}
          value={inputValue[props.name]}
        />
      )}
    </div>
  )
}

export default SingleSelect;